import { TCompanyKind } from "@/types/TCompany";

export const OWNER_KIND: TCompanyKind = {
	collection: "companies",
	basePath: "/companies",
	i18n: "companies",
	title: "company.title",
	showOwnerBadge: true,
	hasBillingTab: true,
};

export const CLIENT_KIND: TCompanyKind = {
	collection: "clients",
	basePath: "/clients",
	i18n: "clients",
	title: "client.title",
	showOwnerBadge: false,
	hasBillingTab: false,
};
